
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as go_ZNA3VfPyAVS38C6b0k_5euk70lh0YwGu2BZtIuwKAMeta } from "/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index_H09Ht1CARqI9pW_45VrkfIUijNlcqTNIMvQhhr_oh2oMMeta } from "/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchIHT7iq6z7XrikYEKX7EM1bqNOqWQldospYuLcJEWTvMMeta } from "/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexoplm2oXwL_45c_SvAYE0eOvDajl8ygLEPl8EIma_28eEAMeta } from "/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93kZzhc6TgdnRBLIDTz3iHw57ScxoTldqthkGP7aV7um0Meta } from "/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexRyGNOejIE6_457soRgzvLyEWEw_45xLQQHo_45oEmKPaYy3zcMeta } from "/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93aWCBiQlU2HjtUOw9SuIq7bi9MfP4i6KOHB_45x5_4511_4gMeta } from "/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexQuZiXtDRkHZHoIdNRTVmTQAxIl2LmC6ljumAG_467mwMeta } from "/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93LBr_SAKM6EtdzhW9Mh614zmQSGt8sAbtwEyLoBRvNVIMeta } from "/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index87aVneaA3ZHjdUMmDUF12nx_45uaqkDgAwU0wP_45H_EaAIMeta } from "/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index_458MNexCQKHWUGcss8oNRmF0ALn1PVYqv8X3yfwFlw8YMeta } from "/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexRyGNOejIE6_457soRgzvLyEWEw_45xLQQHo_45oEmKPaYy3zcMeta || {},
    component: () => import("/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexQuZiXtDRkHZHoIdNRTVmTQAxIl2LmC6ljumAG_467mwMeta || {},
    component: () => import("/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index87aVneaA3ZHjdUMmDUF12nx_45uaqkDgAwU0wP_45H_EaAIMeta || {},
    component: () => import("/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index_458MNexCQKHWUGcss8oNRmF0ALn1PVYqv8X3yfwFlw8YMeta || {},
    component: () => import("/codebuild/output/src1039387905/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]